import { pushAnalyticsEvent, AnalyticsEvent } from 'helpers/analytics';

export const retryAsyncCall = <T>(
  retryFn: () => Promise<T>,
  condition: (condition: T) => boolean,
  analyticsEvent: (data: T, numberOfRetries: number) => AnalyticsEvent,
  maxRetries = 3
): Promise<T> => {
  const helperFunction = async (currentRetry: number, _maxRetries: number): Promise<T> => {
    const returnVal = await retryFn();

    if (condition(returnVal)) {
      pushAnalyticsEvent(analyticsEvent(returnVal, currentRetry));
      return returnVal;
    }

    if (_maxRetries > 0) {
      return helperFunction(currentRetry + 1, _maxRetries - 1);
    }

    pushAnalyticsEvent(analyticsEvent(returnVal, currentRetry));
    return returnVal;
  };

  return helperFunction(0, maxRetries);
};
